// extracted by mini-css-extract-plugin
module.exports = {"web-root":"web-root___3YeMR","web-root-isFold":"web-root-isFold___1lf_X","web-list":"web-list___2wFay","web-icon":"web-icon___2SsG2","norem-list-item":"norem-list-item___2UEvS"};